import { API } from "@/App";

// IATA code → IANA timezone name (e.g. "JFK" -> "America/New_York")
// Starts empty; populated lazily from backend /api/airports/iata-timezone-map
// (computed from airport lat/lon via timezonefinder).
export const AIRPORT_TIMEZONE_MAP = {};

let _loading = null;
let _loaded = false;

/**
 * Fetch the full IATA→IANA timezone map from the backend (8,800+ airports).
 * Idempotent: only fetches once per page load.
 *
 * NOTE: uses a dynamic axios import (instead of `@/utils/api`) so Jest tests
 * that mock just "axios" don't have to also mock the full api-instance
 * module graph. The endpoint is public — no auth interceptor needed.
 */
export const loadAirportTimezoneMap = async () => {
  if (_loaded) return AIRPORT_TIMEZONE_MAP;
  if (_loading) return _loading;
  _loading = (async () => {
    try {
      const axios = (await import("axios")).default;
      const response = await axios.get(`${API}/airports/iata-timezone-map`);
      if (response.data && typeof response.data === "object") {
        Object.assign(AIRPORT_TIMEZONE_MAP, response.data);
        _loaded = true;
      }
    } catch {
      // Silent — duration badge falls back to naive math for flights.
    }
    return AIRPORT_TIMEZONE_MAP;
  })();
  return _loading;
};

export const getAirportTimezone = (iata) => {
  if (!iata) return null;
  return AIRPORT_TIMEZONE_MAP[iata.toUpperCase()] || null;
};
